@if (dangerousGood) {
  <div class="mt-5">
    @switch (dangerousGood.type) {
      <!--Container-->
      @case ('containerGood') {
        <div>
          <app-edit-container-good [containerGood]="$any(dangerousGood)"></app-edit-container-good>
        </div>
      }
      <!--SolidData-->
      @case ('solid') {
        <div>
          <app-edit-solid-good [solid]="$any(dangerousGood)"></app-edit-solid-good>
        </div>
      }
      <!--Gas-->
      @case ('gas') {
        <div>
          <app-edit-gas [gas]="$any(dangerousGood)"></app-edit-gas>
        </div>
      }
      <!--Oil-->
      @case ('oil') {
        <div>
          <app-edit-oil [oil]="$any(dangerousGood)"></app-edit-oil>
        </div>
      }
      <!--Chemical-->
      @case ('chemical') {
        <div>
          <app-edit-chemical [chemical]="$any(dangerousGood)"></app-edit-chemical>
        </div>
      }
    }
  </div>
}
